export enum ETaskStatus {
    ToDo = 'todo',
    Completed = 'completed'
}